module.exports = __webpack_public_path__ + "fonts/karlaregular.d85e4310.woff";